import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useAddSmsTemplateMutation,
  useUpdateSmsTemplateMutation,
} from "../../../features/admin/messageTemplate/messageTemplateApi";
import { toast } from "react-hot-toast";
import { HiArrowLeft } from "react-icons/hi";
import { MdSms } from "react-icons/md";

const TEMPLATE_TYPES = [
  "otp", "registration", "block account", "activate account", "reset",
  "profile completion", "set mpin", "redeem request", "bonus points",
  "birthday wishes", "redemption reminders", "scan_coupon points",
  "complaint message", "gift delivery", "extra points", "account status",
  "point earned", "gift redeem request",
];

export default function AddMessageTemplate() {
  const navigate = useNavigate();
  const location = useLocation();
  const row = location.state || {};
  const isEdit = !!row.edit;

  const [type,       setType]       = useState(row.type       || "");
  const [templateId, setTemplateId] = useState(row.template_id ? String(row.template_id) : "");
  const [text,       setText]       = useState(row.template_text || "");
  const [senderId,   setSenderId]   = useState(row.sender_id   || "");

  const [addSmsTemplate,    { data: addData,    isLoading: adding }]   = useAddSmsTemplateMutation();
  const [updateSmsTemplate, { data: updateData, isLoading: updating }] = useUpdateSmsTemplateMutation();

  useEffect(() => {
    if (addData)    { toast.success(addData.message    || "Template added");   navigate(-1); }
    if (updateData) { toast.success(updateData.message || "Template updated"); navigate(-1); }
  }, [addData, updateData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!type)       { toast.error("Select a template type");  return; }
    if (!templateId) { toast.error("Enter a template ID");     return; }
    if (!text)       { toast.error("Enter the template text"); return; }
    if (!senderId)   { toast.error("Enter a sender ID");       return; }

    const token = sessionStorage.getItem("access_token");
    const body  = { template_id: templateId, template_text: text, sender_id: senderId, type };

    if (isEdit) {
      updateSmsTemplate({ token, id: row.id, body });
    } else {
      addSmsTemplate({
        token,
        body: { ...body, account_id: Number(row.id), template_owned_by_id: row.tenant_id },
      });
    }
  };

  const inp = { border: "1px solid #e2e8f0", borderRadius: "8px", padding: "9px 12px", width: "100%", fontSize: "14px", outline: "none", background: "#fff", boxSizing: "border-box" };
  const lbl = { display: "block", fontSize: "13px", fontWeight: 600, color: "#374151", marginBottom: "6px" };
  const field = { marginBottom: "18px" };
  const busy = adding || updating;

  return (
    <div className="page-content">
      <div style={{ maxWidth: "640px", padding: "24px" }}>

        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "24px" }}>
          <button onClick={() => navigate(-1)}
            style={{ display: "inline-flex", alignItems: "center", gap: "4px", padding: "7px 12px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "7px", fontSize: "13px", cursor: "pointer", color: "#374151" }}>
            <HiArrowLeft size={14} /> Back
          </button>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <MdSms size={18} style={{ color: "#6366f1" }} />
              <h4 style={{ margin: 0, fontSize: "20px", fontWeight: 700, color: "#0f172a" }}>
                {isEdit ? "Edit Template" : "Add SMS Template"}
              </h4>
            </div>
            {isEdit && (
              <p style={{ margin: 0, fontSize: "12px", color: "#64748b", marginTop: "2px" }}>ID: {row.id}</p>
            )}
          </div>
        </div>

        {/* Form */}
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "24px" }}>
          <form onSubmit={handleSubmit}>

            <div style={field}>
              <label style={lbl}>Template Type *</label>
              <select style={inp} value={type} onChange={e => setType(e.target.value)}>
                <option value="">— Select type —</option>
                {TEMPLATE_TYPES.map(t => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </select>
            </div>

            <div style={field}>
              <label style={lbl}>Template ID *</label>
              <input style={inp} type="text" value={templateId}
                placeholder="e.g. 1234567890123456789"
                onChange={e => setTemplateId(e.target.value)} />
            </div>

            <div style={field}>
              <label style={lbl}>Template Text *</label>
              <textarea style={{ ...inp, height: "100px", resize: "vertical" }} value={text}
                placeholder="Enter SMS template message text…"
                onChange={e => setText(e.target.value)} />
              <p style={{ margin: "4px 0 0", fontSize: "11px", color: "#94a3b8" }}>{text.length} chars</p>
            </div>

            <div style={field}>
              <label style={lbl}>Sender ID *</label>
              <input style={inp} type="text" value={senderId}
                placeholder="e.g. GENIFY"
                onChange={e => setSenderId(e.target.value)} />
            </div>

            <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end", marginTop: "8px" }}>
              <button type="button" onClick={() => navigate(-1)}
                style={{ padding: "9px 20px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "14px", cursor: "pointer", color: "#374151" }}>
                Cancel
              </button>
              <button type="submit" disabled={busy}
                style={{ padding: "9px 20px", background: "#2563eb", color: "#fff", border: "none", borderRadius: "8px", fontSize: "14px", fontWeight: 600, cursor: busy ? "not-allowed" : "pointer", opacity: busy ? 0.7 : 1 }}>
                {busy ? "Saving…" : isEdit ? "Update Template" : "Add Template"}
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
}
